import { RecivePeymentForm } from "../components/RecivePeyment/RecivePeymentForm"
import { useEffect, useState } from "react";



export const ReceivePayment = () =>{
    const [isDark, setIsDark] = useState(
        () =>
          typeof window !== "undefined" && document.body.classList.contains("dark")
      );
    
      useEffect(() => {
        const checkDark = () => setIsDark(document.body.classList.contains("dark"));
        checkDark();
        const observer = new MutationObserver(() => {
          checkDark();
        });
        observer.observe(document.body, {
          attributes: true,
          attributeFilter: ["class"],
        });
        return () => {
          observer.disconnect();
        };
      }, []);
    
    return(
      <div className="w-full h-screen bg-white dark:bg-[#0D1117]">
      <div className="mb-6 p-3 lg:p-6">
      
       <h1
  className="
    relative inline-block text-3xl font-bold mb-6 
    text-[#0010c6] dark:text-white
    after:content-[''] after:block after:w-full after:h-[4px] 
    after:bg-[#0010c6] after:mt-[10px] dark:after:bg-[#ffffff]
  "
>
دریافت وجه به لینک
</h1>
 
     </div>
        <div className="col-span-full my-auto flex flex-col">
         
            <RecivePeymentForm/>
        </div>
       </div> 
    )
}